export const MEMBER_REGISTRATION_STATUS = {
  PAID: "paid",
  SCHEDULED_FREE: "scheduled_free",
  FREE: "free",
};

export function getMemberRegistrationAvailability(raceData, nowMs = Date.now()) {
  const metadata = raceData?.metadata || {};
  const memberRegistrationMode = metadata.memberRegistrationMode;
  const isConfiguredFree =
    typeof memberRegistrationMode === "string" &&
    memberRegistrationMode.trim().toLowerCase() === "free";

  if (!isConfiguredFree) {
    return { status: MEMBER_REGISTRATION_STATUS.PAID, startsAtMs: null };
  }

  const configuredStartsAt = metadata.memberFreeRegistrationStartsAt;
  if (configuredStartsAt === undefined || configuredStartsAt === null || configuredStartsAt === "") {
    return { status: MEMBER_REGISTRATION_STATUS.FREE, startsAtMs: null };
  }

  if (typeof configuredStartsAt !== "string") {
    return { status: MEMBER_REGISTRATION_STATUS.PAID, startsAtMs: null };
  }

  const startsAtMs = Date.parse(configuredStartsAt.trim());
  if (!Number.isFinite(startsAtMs)) {
    return { status: MEMBER_REGISTRATION_STATUS.PAID, startsAtMs: null };
  }

  return {
    status:
      startsAtMs > nowMs
        ? MEMBER_REGISTRATION_STATUS.SCHEDULED_FREE
        : MEMBER_REGISTRATION_STATUS.FREE,
    startsAtMs,
  };
}

export function formatMemberFreeRegistrationDate(startsAtMs) {
  if (!Number.isFinite(startsAtMs)) return "";

  return new Intl.DateTimeFormat("en-CA", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "America/Toronto",
  }).format(new Date(startsAtMs));
}
